export async function retryGetDocs<F extends (...args: any[]) => Promise<any>>(
  getDocsFn: F,
  maxRetries = 5,
  retryDelay = 1000
) {
  let attempt = 0

  while (attempt < maxRetries) {
    try {
      const result = await getDocsFn()
      return result // Success!
    } catch (error: any) {
      console.warn(
        `Attempt ${attempt + 1} failed: Firestore unavailable. Retrying in ${
          retryDelay / 1000
        }s...`,
        error
      )
      attempt++
      await new Promise((resolve) => setTimeout(resolve, retryDelay))
    }
  }
  throw new Error(`Failed after ${maxRetries} retries.`)
}
